import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  //#region Properties
  height = signal(0);
  //#endregion

}
